import { motion } from "framer-motion";
import { Clock, ShieldCheck, TrendingUp, Repeat } from "lucide-react";
import { SectionHeader } from "@/components/sections/SectionHeader";

const ITEMS = [
  { icon: Clock, title: "Economisești timp", desc: "Produse gata de lucru, integrate în fluxul tău de bucătărie." },
  { icon: TrendingUp, title: "Reduci pierderile", desc: "Porționare predictibilă și constantă, fără surprize la final de zi." },
  { icon: Repeat, title: "Servești mai rapid", desc: "Coacere ușoară. Vitrina e plină când e plin localul." },
  { icon: ShieldCheck, title: "Gust constant", desc: "Aceeași textură și aromă, lot după lot. Fără noroc, doar meserie." },
];

export default function ProblemAudit() {
  return (
    <section data-testid="audit-section" className="section-pad bg-bg">
      <div className="max-w-7xl mx-auto container-px">
        <SectionHeader
          eyebrow="Realitatea din bucătărie"
          title="În HoReCa, gustul bun trebuie să fie și constant."
          subtitle="Când ai clienți la masă, nu ai timp de produse care ies diferit de la o zi la alta. Ai nevoie de gust, aspect, siguranță și predictibilitate. DOTAPAN livrează produse create pentru ritmul real al unei bucătării: rapide, constante, ușor de integrat."
          testId="audit-header"
        />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ITEMS.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="card-soft p-7"
              data-testid={`audit-card-${i}`}
            >
              <div className="h-11 w-11 rounded-full border border-gold/40 flex items-center justify-center bg-surface-2">
                <item.icon className="h-5 w-5 text-gold" />
              </div>
              <h3 className="mt-5 font-display text-xl text-text">{item.title}</h3>
              <p className="mt-2 text-sm text-text-soft leading-relaxed">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
